import { useState } from "react";
import { Typography, Grid } from "@mui/material";
import { usePermissionContext } from "../../context/PermissionContext";
import { useGetHubsQuery } from "../../sources/queries";

import {
  StyledHubsPageContainer,
  StyledHubsRestrictedPageContainer,
} from "../styles";

import { CloseReasonDialog } from "../../components/modals/CloseReasonDialog";
import { SearchHeader } from "../../components/SearchHeader";
import { HubInfo } from "../../components/HubInfo";
import { HubInfoSkeleton } from "../../components/placeholders/HubInfoSkeleton";
import { NoHubs } from "./NoHubs";
import { LocationCard } from "../../components/LocationCard";

export const HubsPage = () => {
  const [open, setOpen] = useState(false);
  const [hubStatus, setHubStatus] = useState(null);

  const [search, setSearch] = useState("");
  const { data, isLoading } = useGetHubsQuery({ cacheTime: 0, search });
  const hubs = data?.data || [];
  const { availablePlaces, hasHubEditPermission, hasReadOnlyPermission, hasDeliveryAreaServingHubPermission,hasDeliveryAreaDeliveryFeePermission } =
    usePermissionContext();

  const { availableCities = [], availableCountries = [] } =
    availablePlaces || {};

  const onCancel = () => {
    setOpen(false);
  };
  const onAction = ({ message }) => {
    const { variables, mutation } = hubStatus;
    mutation({ ...variables, message });
    setOpen(false);
  };

  const onHubStateChange = (variables, mutation) => {
    if (variables?.state === "OPEN") {
      mutation(variables);
    } else {
      setOpen(true);
      setHubStatus({ variables, mutation });
    }
  };

  if (hasHubEditPermission || hasReadOnlyPermission || hasDeliveryAreaServingHubPermission || hasDeliveryAreaDeliveryFeePermission) {
    return (
      <StyledHubsPageContainer maxWidth="lg">
        <SearchHeader header="HUBS" setSearch={setSearch} />
        <NoHubs
          hubs={hubs}
          isLoading={isLoading}
          message={"No hubs available"}
        />
        {isLoading && (
          <>
            <HubInfoSkeleton />
            <HubInfoSkeleton />
          </>
        )}

        {hubs?.map((hub) => {
          return (
            <HubInfo
              key={hub.id}
              onHubStateChange={onHubStateChange}
              {...hub}
            />
          );
        })}
        <CloseReasonDialog
          open={open}
          onCancel={onCancel}
          onAction={onAction}
          title={`Close ${hubStatus?.variables?.id} hub?`}
          message="If you sure you want to close this hub please choose the reason for closing."
          actionLabel="Close Hub"
          actionButtonProps={{ color: "primary" }}
        />
      </StyledHubsPageContainer>
    );
  }

  return (
    <StyledHubsRestrictedPageContainer maxWidth="lg">
      <Grid container spacing={6}>
        {!!availableCities.length && (
          <Grid item xs={12}>
            <Typography variant="h4">Managed Cities</Typography>
          </Grid>
        )}
        {availableCities.map((el, index) => (
          <Grid key={index} item>
            <LocationCard {...el} />
          </Grid>
        ))}

        {!!availableCountries.length && (
          <Grid item xs={12}>
            <Typography variant="h4">Managed Countries</Typography>
          </Grid>
        )}
        {availableCountries.map((el, index) => (
          <Grid key={index} item>
            <LocationCard {...el} />
          </Grid>
        ))}
      </Grid>
    </StyledHubsRestrictedPageContainer>
  );
};
